import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import {
	CreateDeviceContext,
	ICreateDeviceContext,
} from 'modules/Devices/CreateDevice/createDeviceState/createDeviceContext';
import { NEW_BANK_SETTINGS_BLOCK_PREFIX } from 'appConstants';
import style from './AddNewBlockBtn.module.scss';

const AddNewBlockBtn: React.FC = () => {
	const { addBankSettingsBlock } = useContext<ICreateDeviceContext>(CreateDeviceContext);
	const [blockIDCounter, setBlockIDCounter] = useState(1);

	const handleClick = () => {
		setBlockIDCounter((prevState) => prevState + 1);

		const blockId = `${NEW_BANK_SETTINGS_BLOCK_PREFIX}/${blockIDCounter}`;

		addBankSettingsBlock({
			id: blockId,
			restaurantBankSettingId: null,
			terminalId: '',
			m4BankSettingCredentials: {
				login: null,
				password: null,
			},
			toucanBankSettingCredentials: {
				login: null,
				password: null,
			},
		});
	};

	return (
		<Button
			className={style.button}
			theme="secondaryPurple"
			data-test="AddNewBlockBtn"
			onClick={handleClick}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addNewBlockButton" asFragment={true} />
		</Button>
	);
};

export default AddNewBlockBtn;
